export default __webpack_public_path__ + "static/media/Class-9-State-SocialScience.00c0e0e1.pdf";